import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface SelectionRabItemMenuItemType {
    isActive: boolean;
    variant: DefaultComponentVariantType | null;
}

const setSelectionRabItemMenuItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: 4px;
            font-weight: ${theme.star.fontWeight.bold};
        `;
    }
    return css`
        font-weight: ${theme.star.fontWeight.medium};
    `;
};

export const SelectionRabItemMenuItem = withConfig(theme => styled('li', { label: 'SelectionRabItemMenuItem' })<SelectionRabItemMenuItemType>`
    ${({ variant }): SerializedStyles => setSelectionRabItemMenuItem(variant, theme)}
    background: ${({ isActive }): string => isActive === true ? theme.star.marketGroupGoalscorer.filters.bgColorSecondary : 'transparent'};
    border: 1px solid ${theme.star.marketGroupGoalscorer.filters.borderColor};
    color: ${({ isActive }): string => isActive === true ? theme.star.marketGroupGoalscorer.filters.txtColorSecondary : theme.star.marketGroupGoalscorer.filters.txtColor};
    transition: .2s ease background-color, .2s ease color;
    font-size: ${theme.star.fontSize.small};
    padding: 7px 12px;
    margin-right: 4px;
    cursor: pointer;
    line-height: 1.3334;
    &:hover {
        color: ${theme.star.marketGroupGoalscorer.filters.txtColorSecondary};
        background: ${theme.star.marketGroupGoalscorer.filters.bgColorSecondary};
    }
    &:not(:last-of-type) {
        margin-right: 4px !important;
    }
`);
